import React, { Suspense, useEffect } from "react";

/** Vendors */
import { RouterProvider } from "react-router-dom";
import { App, ConfigProvider } from "antd";

/** Custom APIs */
import auth from "@api/auth";

/** Custom Components */
import router from "./router/index";

const theme = {
  token: {
    borderRadius: 4,
    borderRadiusLG: 8,
    colorLink: "#fff",
    colorPrimary: "#002c54",
    fontFamily: "Poppins",
  },
};

function TheApp() {
  useEffect(() => {
    auth.create.visitor.token();
  }, []);

  return (
    <App>
      <ConfigProvider theme={theme}>
        <Suspense fallback={<React.Fragment>Loading...</React.Fragment>}>
          <RouterProvider router={router} />
        </Suspense>
      </ConfigProvider>
    </App>
  );
}

export default TheApp;
